/**
 * @module components\ghTable\dataTable\dataRow\dataCell
 */
import Vue, { CreateElement } from "vue";
import Component from "vue-class-component";
import { Inject, Prop } from "vue-property-decorator";
import DataCellBase from "./dataCellBase";
import TextCell from "./textCell/textCell";
import DateCell from "./dateCell/dateCell";
import SelectionCell from "./selectionCell/selectionCell";
import IconCell from "./iconCell/iconCell";
import ImageCell from "./imageCell/imageCell";
import ActionsCell from "./actionsCell/actionsCell";
import CheckboxCell from "./checkboxCell/checkboxCell";
import RangeCell from "./rangeCell/rangeCell";

@Component({
  components: {
    ["table-cell-string"]: TextCell,
    ["table-cell-date"]: DateCell,
    ["table-cell-selection"]: SelectionCell,
    ["table-cell-icon"]: IconCell,
    ["table-cell-image"]: ImageCell,
    ["table-cell-actions"]: ActionsCell,
    ["table-cell-boolean"]: CheckboxCell,
    ["table-cell-range"]: RangeCell
  }
})
export default class DataCell extends DataCellBase {
  private map = {
    ["string"]: "table-cell-string",
    ["number"]: "table-cell-string",
    ["boolean"]: "table-cell-boolean",
    ["selection"]: "table-cell-selection",
    ["image"]: "table-cell-image",
    ["icon"]: "table-cell-icon",
    ["actions"]: "table-cell-actions",
    ["O-sort"]: "table-cell-actions",
    ["date"]: "table-cell-date",
    ["range"]: "table-cell-range"
  };

  render(h: CreateElement) {
    let type = this.header.type as string;
    let el = "table-cell-string";
    if (type) {
      if (this.map[type]) {
        el = this.map[type];
      }
    }
    return h(el, {
      props: {
        props: this.props,
        header: this.header,
        rowOptions: this.rowOptions
      }
    });
  }
}
